export const BIDTYPE = [
  {
    value: 3,
    label: '广泛匹配'
  },
  {
    value: 4,
    label: '智能短语匹配'
  },
  {
    value: 2,
    label: '普通短语匹配'
  },
  {
    value: 1,
    label: '精确匹配'
  }
]

export const PROVINCES_OF_CHINA = [
  '北京',
  '天津',
  '上海',
  '重庆',
  '河北',
  '河南',
  '云南',
  '辽宁',
  '黑龙江',
  '湖南',
  '安徽',
  '山东',
  '新疆',
  '江苏',
  '浙江',
  '江西',
  '湖北',
  '广西',
  '甘肃',
  '山西',
  '内蒙古',
  '陕西',
  '吉林',
  '福建',
  '贵州',
  '广东',
  '青海',
  '西藏',
  '四川',
  '宁夏',
  '海南',
  '台湾',
  '香港',
  '澳门',
  '其他'
]

export const INDICE_DEFAULT = [
  ['_', '请选择指标'],
  ['pv', '浏览量(PV)'],
  ['uv', '访客数(UV)'],
  ['ipnum', 'IP'],
  ['newvst', '新独立访客'],
  ['tnum', '自定义转化次数'],
  ['atime', '平均访问时长']
]

export const INDICE_MENU = [
  { value: '_', label: '请选择指标' },
  { value: 'adpv', label: '展现量' },
  { value: 'adclick', label: '点击量' },
  { value: 'adctr', label: '点击率' },
  { value: 'adcost', label: '消费' },
  { value: 'adcpc', label: 'CPC' },
  { value: 'adcpm', label: 'CPM' },
  { value: 'pv', label: '浏览量(PV)' },
  { value: 'uv', label: '访客数(UV)' },
  { value: 'avc', label: '访问次数' },
  { value: 'tnum', label: '自定义转化次数' },
  { value: 'atime', label: '平均访问时长' },
  { value: 'jrate', label: '跳出率' }
]

export const INDICE_MAP = {
  pv: '浏览量(PV)',
  uv: '访客数(UV)',
  ipnum: 'IP',
  newvst: '新独立访客',
  jrate: '跳出率',
  atime: '平均访问时长',
  anum: '平均访问页数',
  vnum: '访问次数',
  tnum: '自定义转化次数 ',
  trate: '转化率',
  innum: '入口页次数',
  exitnum: '退出页次数',
  exitrate: '退出率',
  adcpc: 'CPC',
  adcost: '消费',
  adpv: '展现量',
  adclick: '点击量',
  adctr: '点击率',
  adcpm: 'CPM',
  income: '转化价值',
  snum: '搜索指数',
  uvrate: '访客渗透',
  ordernum: '订单量',
  orderprice: '订单金额',
  orderrate: '订单转化率',
  reg: '注册量',
  regrate: '注册转化率',
  reachrate: '到达率'
}

export const PROVINCES_OF_DIANJING = [
  '全国',
  '北京市',
  '上海市',
  '天津市',
  '重庆市',
  '河北省',
  '山西省',
  '内蒙古',
  '辽宁省',
  '吉林省',
  '黑龙江省',
  '江苏省',
  '浙江省',
  '安徽省',
  '福建省',
  '江西省',
  '山东省',
  '河南省',
  '湖北省',
  '湖南省',
  '广东省',
  '广西',
  '海南省',
  '四川省',
  '贵州省',
  '云南省',
  '西藏',
  '陕西省',
  '甘肃省',
  '宁夏',
  '青海省',
  '新疆',
  '香港',
  '澳门',
  '台湾省'
]

export const USER_ATTR_MAP = {
  gender: {
    1: '男',
    2: '女'
  },

  age: {
    1: '< 19', // '小于19',
    2: '19-24',
    3: '25-34',
    4: '35-49',
    5: '>= 50'
  },

  edu: {
    1: '初中以下',
    2: '高中',
    3: '大学',
    4: '研究生以上'
  },

  job: {
    1: '学生',
    2: '公司员工',
    3: '公司经理',
    4: '公务员',
    5: '机构组织',
    6: '个体经营',
    7: '自由职业',
    8: '工人',
    9: '农民',
    10: '文化娱乐体育行业'
  }
}

export const UA_NAME_MAP = {
  MobileBrowser: 'APP内嵌浏览器',
  '360SE': '360安全浏览器',
  '360EE': '360极速浏览器',
  Sougou: '搜狗高速浏览器',
  Liebao: '猎豹安全浏览器',
  Weixin: '微信',
  MQQBrowser: 'QQ浏览器移动版',
  QQBrowser: 'QQ浏览器',
  UCBrowser: 'UC浏览器',
  Baidu: '百度浏览器',
  BaiduMobile: '百度浏览器移动版',
  '2345Explorer': '2345浏览器',
  Aoyou: '遨游云浏览',
  Theworld: '世界之窗浏览器',
  GreenBrowser: '绿色浏览器',
  MiuiBrowser: '小米浏览器',
  Weibo: '新浪微博客户端',
  TaoBrowser: '淘宝浏览器',
  Opera: '欧朋浏览器'
}



// WEBPACK FOOTER //
// ./src/pageview/web/constants.js